import { apiConstant } from "./apiConstants"
import { Request } from "./service"
import { UnauthRequest } from "./unauthService"

// const {url, method, params, formDataFlag, progressHandler, headers, controller} = apiParams

export const testApi = () => {
   
    return Request({url: apiConstant.testApi, method: 'Get'})
}


// export const userLogin = (params) => {
//     return Request(apiConstant.user.login, 'Get', params, false)
// }

//************************SESSIONS API SERVICES**************************************** */

export const checkInvitationApi= (params) => {
    return UnauthRequest({url: apiConstant.user.checkInvitation, method: 'Get', headers: params.header })
}

//********************USER API SERVICES************************************** */

export const userSignup= (params) => {
    return Request({url: apiConstant.user.signup, method: 'Post', params, formDataFlag: true})
}
export const appleSign= (params) => {
    return Request({url: apiConstant.user.appleSign, method: 'Post', params, formDataFlag: true})
}
export const verifyAppleUser= (params) => {
    return Request({url: apiConstant.user.verifyAppleUser, method: 'Get', params, formDataFlag: false})
}

// export const userSignin= (params) => {
//     return Request(apiConstant.user.signin, 'Get', params, false)
// }

export const userSignin= (params) => {
    return Request({uirl:`${apiConstant.user.signin}?product_id=${params.product_id}`, method: 'Get', params: params.param, formDataFlag: false})
}

export const userSigninApi= (params) => {
    return Request({url:`${apiConstant.user.signin}?product_id=${params.product_id}`, method: 'Get', params: params.param, formDataFlag: false})
}

export const checkEmail = (params) => {
    return Request({url: apiConstant.user.checkEmail, method: 'Get', params, formDataFlag: false})
}
export const resendLink = (params) => {
    return Request({url: apiConstant.user.resendLink, method: 'Get', params, formDataFlag: false })
}


export const forgotPassword = (params) => {
    return Request({url: apiConstant.user.forgotPassword, method: 'Get', params, formDataFlag: false})
}

export const forgotPasswordApi = (params) => {
    return UnauthRequest({url: apiConstant.user.forgotPassword, method: 'Get', params, formDataFlag: false})
}


export const checkVerificationToken = (params) => {
    return UnauthRequest({url: apiConstant.user.checkVerificationTokenValidity, method: 'Get', params, formDataFlag: true})
}
export const checkResetTokenValidityApi = (params) => {
    return UnauthRequest({url: apiConstant.user.checkVerificationTokenValidity, method: 'Get', params, formDataFlag: false})
}

export const checkVerificationTokenApi = (params) => {
    return Request({url: `${apiConstant.user.verifyUserMailToken}?token=${params.token}`, method: 'Get', params, formDataFlag: false})
}


export const verifyUserMail = (params) => {
    return Request({url: apiConstant.user.verifyUserMail, method:'Get', params, formDataFlag: false})
}

export const resetPassword = (params) => {
    return Request({url: apiConstant.user.resestPassword, method: 'Put', params, formDataFlag:true})
}

export const resetPasswordApi = (params) => {
    return Request({url: apiConstant.user.resetPassword, method:  'Put', params,formDataFlag: true})
}


export const deleteUser= (params) => {
    return Request({url: `${apiConstant.user.deleteUser}/${params.id}`, method: 'Delete', params: params.param, formDataFlag: true})
}

export const memberInvitationApi = (params, headers) => {
    return Request({url: apiConstant.user.memberInvitation, method: 'Put', params, formDataFlag: true, headers})
}

export const userRoleApi = (params) => {
    return Request({url: apiConstant.user.userRole, method: 'Get', params, formDataFlag: false})
}

export const approveUserApi = (params) => {
    return Request({url: apiConstant.user.approveUser, method: 'Get', params, formDataFlag: false})
}

//************************EVENTS API SERVICES**************************************** */

export const createEvent= (params) => {
    return Request({url: apiConstant.event.create, method: 'Post', params, formDataFlag: true})
}

export const editEvent= (params) => {
    return Request({url: `${apiConstant.event.create}/${params.id}`, method: 'Put', params: params.param, formDataFlag: true})
}
export const cancelEvent= (params) => {
    return Request({url: apiConstant.event.cancelEvent, method: 'Put', params, formDataFlag: false})
}

export const addEvent = (params) => {
    return Request({url: apiConstant.event.addEvent, method: "Post", params, formDataFlag: true});
  };



export const eventsList= () => {
    return Request({url: apiConstant.event.create, method: 'Get'})
}

export const getTeamEventsListApi = (params) => {
    return Request({url: apiConstant.event.create, method: 'Get', params, formDataFlag: false})
}

export const eventDetails= (params) => {
    return Request({url:`${apiConstant.event.create}/${params.id}`,method:  'Get'})
}

export const uploadVideo= (params) => {
    return Request({url: apiConstant.event.uploadVideo, method: 'Post', params: params.data, formDataFlag: true, progressHandler: params.progress, headers:  params.header, controller: params.controller} )
}

export const uploadList= (params) => {
    return Request({url: apiConstant.event.uploadList, method:  'Get', params, formDataFlag: false})
}

export const uploadListToLinkEvent = (params) => {
    return Request({url: apiConstant.event.uploadListToLinkEvent, method: 'Get', params, formDataFlag: false})
}

export const importFiles= (params) => {
    return Request({url: apiConstant.event.importFiles, method: 'Post', params, formDataFlag: true})
}

export const allMediaFiles = () => {
    return Request({url: apiConstant.event.allMediaFiles, method: 'Get'})
}

export const markViewed = (params) => {
    return Request({url: apiConstant.event.markViewed, method: 'Put', params, formDataFlag: false})
}

export const createZippedMedia= (params) => {
    return Request({url: apiConstant.event.createZippedMedia, method:  'Post', params, formDataFlag: true})
}

export const downloadZippedMedia = (params) => {
    return Request({url: apiConstant.event.downloadZippedMedia, method: 'Get', params, formDataFlag: false} )
}

export const downloadMedia = (params) => {
    return Request({url: apiConstant.event.downloadMedia, method:  'Get', params, formDataFlag: false} )
}

export const favoriteMedia = (params) => {
    return Request({url: apiConstant.event.favoriteMedia, method: 'Post', params, formDataFlag: false,} )
}

export const deleteMedia= (params) => {
    return Request({url: `${apiConstant.event.uploadList}/${params.id}`, method: 'Delete', params: params.param, formDataFlag: true})
}

export const guestEventDetails= (params) => {
    return Request({url: apiConstant.event.guestEvent, method: 'Get', params, formDataFlag: false})
}

export const acceptFinalVideo= (params) => {
    return Request({url: apiConstant.event.acceptFinalVideo, method: 'Put', params, formDataFlag: false})
}

export const myMediaFileProjectsApi= () => {
    return Request({url: apiConstant.event.myMediaFileProjects , method: 'Get'})
}


export const myMediaFilesOfProjectApi = (params) => {
    return Request({url: apiConstant.event.myMediaFilesOfProject, method:  'Get', params, formDataFlag: false})
}

//   project roles api///

export const viewProjectMembersApi = (params) => {
    return Request({url: apiConstant.event.viewProjectMember, method: 'Get', params, formDataFlag: false} )
}

export const addProjectMemberApi = (params) => {
    return Request({url: apiConstant.event.addProjectMember , method: 'Post', params, formDataFlag: true})
}

export const updateProjectMemberRoleApi = (params) => {
    return Request({url: apiConstant.event.updateProjectMemberRole, method: 'Put', params, formDataFlag:true})
}

export const changeProjectAdminApi = (params) => {
    return Request({url: apiConstant.event.changeProjectAdmin, method:  'Put', params, formDataFlag: true})
}

export const removeProjectAdminApi = (params) => {
    return Request({url: apiConstant.event.removeProjectAdmin, method: 'Put', params, formDataFlag: true})
}


export const removeProjectMemberApi = (params) => {
    return Request( {url: apiConstant.event.removeProjectMember, method: 'Delete', params, formDataFlag: true})
}


//************************OPTIONS API SERVICES**************************************** */

export const genreList = (params) => {
    return Request({url: apiConstant.options.genre, method: 'Get', params, formDataFlag: false})
}

export const toneList = (params) => {
    return Request({url: apiConstant.options.tone, method: 'Get', params, formDataFlag: false})
}

export const phoneCountRanges = (params) => {
    return Request({url: apiConstant.options.phoneCount, method: 'Get', params, formDataFlag: false})
}
export const qualityOptionList = (params) => {
    return Request({url: apiConstant.options.qualityOption, method: "Get", params, formDataFlag: false});
  };
  export const eventTypeList = (params) => {
    return Request({url: apiConstant.options.eventType, method: 'Get', params, formDataFlag: false})
}

export const videoLengthList = (params) => {
    return Request({url: apiConstant.options.videoLength, method: 'Get', params, formDataFlag: false})
}
  export const eventStatusType = (params) => {
    return Request({url: apiConstant.options.statusType, method: 'Get', params, formDataFlag: false})
}

export const getRolesApi = (params) => {
    return Request({url: `${apiConstant.options.role}?product_id=${params.product_id}`, method:  'Get'})
}

export const getAssetOptionsApi = (params) => {
    return Request({url: `${apiConstant.options.asset}`, method: 'Get' , params, formDataFlag: false})
}
// ////////////////////////////////consent api//////////////////////////////////

export const consentDetail = (params) => {
    return Request({url: apiConstant.consents.consentDetail, method: 'Get', params, formDataFlag: false })
}

export const eventVideoUploadConsent= (params) => {
    return Request({url: apiConstant.consents.eventVideoUploadConsent, method:  'Post', params, formDataFlag: true})
}

////////////////////////////////revision////////////////////////////////

export const videoUrl = (params) => {
    return Request({url: apiConstant.revision.videoUrl, method: 'Get', params, formDataFlag: false })
}
export const checkNewVideo = (params) => {
    return Request({url: apiConstant.revision.checkNewVideo, method: 'Get', params, formDataFlag:  false })
}
export const createRevision = (params) => {
    return Request({url: apiConstant.revision.createRevision, method: 'Post', params, formDataFlag: true })
}
export const getRevisionLogsApi = (params) => {
    return Request({url: apiConstant.revision.getRevisionLogs, method: 'Get', params, formDataFlag: false })
}
export const createRevisionLogs = (params) => {
    return Request({url: `${apiConstant.revision.getRevisionLogs}?user_id=${params.id}`, method: 'Post', params: params.param, formDataFlag: true })
}
export const submitRevision = (params) => {
    return Request({url: `${apiConstant.revision.submitRevision}?revision_id=${params.id}`, method: 'Put' })
}
export const disableRevisionTutorial = () => {
    return Request({url: apiConstant.revision.disableRevisionTutorial, method: 'Put' })
}

////////////////////////organisation apis/////////////////////////////

export const viewOrganisationMembersApi = (params) => {
    return Request({url: apiConstant.organisation.viewOrganisationMember, method: 'Get', params, formDataFlag: false })
}

export const addOrganisationMemberApi = (params) => {
    return Request({url: apiConstant.organisation.addOrganisationMember , method: 'Post', params, formDataFlag: true})
}

export const updateOrganisationMemberRoleApi = (params) => {
    return Request({url: apiConstant.organisation.updateOrganisationMemberRole, method: 'Put', params, formDataFlag: true})
}

export const changeOrganisationAdminApi = (params) => {
    return Request({url: apiConstant.organisation.changeAdmin, method: 'Put', params, formDataFlag: true})
}

export const removeOrganisationAdminApi = (params) => {
    return Request({url: apiConstant.organisation.removeAdmin, method: 'Put', params, formDataFlag: true})
}

export const removeOrganisationMemberApi = (params) => {
    return Request({url: `${apiConstant.organisation.removeOrganisationMember}?user_id=${params.user_id}`,  method:'Put'})
}

export const updateOrganisationNameApi = (params) => {
    return Request({url: apiConstant.organisation.updateOrganisationName, method: 'Put', params, formDataFlag: true})
}

////////////////////teams api/////////////////////////////////

export const createTeamApi = (params) => {
    return Request({url: apiConstant.team.createTeam , method: 'Post', params, formDataFlag: true})
}

export const getAllTeamsApi = (params) => {
    return Request({url: apiConstant.team.createTeam, method: 'Get', params, formDataFlag: false })
}

export const updateTeamPrivacyApi = (params) => {
    return Request({url: apiConstant.team.updateTeamPrivacy, method: 'Put', params, formDataFlag: true})
}

export const renameTeamApi = (params) => {
    return Request({url: apiConstant.team.renameTeam, method: 'Put', params, formDataFlag: true})
}

export const removeTeamApi= (params) => {
    return Request( {url: apiConstant.team.removeTeam, method: 'Delete', params, formDataFlag: true})
}

export const addTeamMemberApi = (params) => {
    return Request({url: apiConstant.team.addTeamMember , method: 'Post', params, formDataFlag: true})
}

export const viewTeamMembersApi = (params) => {
    return Request({url: `${apiConstant.team.viewTeamMembers}?team_id=${params.team_id}`, method: 'Get' })
}

export const updateTeamMemberRoleApi = (params) => {
    return Request({url: apiConstant.team.updateTeamMemberRole, method: 'Put', params, formDataFlag: true})
}

export const changeTeamAdminApi = (params) => {
    return Request({url: apiConstant.team.changeTeamAdmin,  method: 'Put', params, formDataFlag: true})
}
// unchanged params structure...............................................................
export const removeTeamAdminApi = (params) => {
    return Request(apiConstant.team.removeTeamAdmin, 'Put', params, true)
}

export const removeTeamMemberApi = (params) => {
    return Request( apiConstant.team.removeTeamMember, 'Delete', params, true)
}

//////////permission//////////////////////////

export const getPermissionsApi = (params) => {
    return Request(`${apiConstant.permission.getPermission}?product_id=${params.id}`, 'Get')
}


////////////////////////////roles/////////////////////////////

export const createRoleApi = (params) => {
    return Request(apiConstant.roles.role , 'Post', params, true)
}

export const updateRoleApi = (params) => {
    return Request(`${apiConstant.roles.role}/${params.id}`, 'Put', params.params, true)
}

export const showRoleApi = (params) => {
    return Request(`${apiConstant.roles.role}/${params.id}`, 'Get')
}


///////////////////////////////theme///////////////////////////////////////


export const getThemeApi = (params) => {
    return Request(apiConstant.themes.theme, 'Get', params, false )
}


export const createThemeApi = (params) => {
    return Request(apiConstant.themes.theme , 'Post', params, true)
}

export const updateThemeApi = (params) => {
    return Request(apiConstant.themes.theme , 'Put', params, true)
}

export const deleteThemeApi = (params) => {
    return Request(`${apiConstant.themes.removeTheme}`, 'Put', params, false)
}
//////////////////////////assets////////////////////////////

export const getAllAssetsApi = (params) => {
    return Request(apiConstant.assets.assetFile, 'Get', params, false )
}


// export const createAssetApi = (params) => {
//     return Request(apiConstant.assets.assetFile , 'Post', params, true)
// }

export const createAssetApi = (params) => {
    return Request(apiConstant.assets.assetFile, 'Post', params.data, true, params.progress, params.header, params.controller )
}

export const deleteAssetFileApi = (params) => {
    return Request(`${apiConstant.assets.assetFile}/${params.id}`, 'Delete', params.param, true)
}

////////////////////////////////// event Notes //////////////////////////////////////


export const getAllEventNotesApi = (params) => {
    return Request(`${apiConstant.eventNotes.manageEventNotes}?event_id=${params.event_id}`, 'Get')
}

export const uploadEventNoteApi = (params) => {
    return Request(apiConstant.eventNotes.manageEventNotes, 'Post', params.data, true, params.progress, params.header, params.controller )
}

export const deleteEventNoteApi = (params) => {
    return Request(`${apiConstant.eventNotes.manageEventNotes}/${params.id}`, 'Delete', params.param, true)
}

export const editNotesToEditorApi = (params) => {
    return Request(apiConstant.event.editNotes, "Patch", params, true);
};


/////////////////////////// guest review //////////////////////////////////////////////


export const registerGuestApi = (params) => {
    return Request(apiConstant.guest.registerGuestReviewer , 'Post', params, true)
}

export const getGuestEventDetailsApi = (params) => {
    return Request(apiConstant.guest.eventDetails, 'Get', params, false )
}

export const createGuestLogApi = (params) => {
    return Request(apiConstant.guest.createLog , 'Post', params, true)
}


//_____________________________________________________________________apis that need format change in params

///////////////////////////////pharoah apis start //////////////////////////////////////////////////////

/////////////////////////////user management///////////////////////////


export const viewMembersApi = (params) => {
    return Request({url: apiConstant.userManagement.viewMember, method: 'Get', params, formDataFlag: false })
}

export const addMemberApi = (params) => {
    return Request({url: apiConstant.userManagement.addMember , method: 'Post', params, formDataFlag: true})
}

export const acceptMemberInvitationApi = (params) => {
    return UnauthRequest({url: apiConstant.userManagement.acceptMemberInvitation , method: 'Post', params: params.params, formDataFlag: true, headers: params.header})
}

export const updateMemberRoleApi = (params) => {
    return Request({url: apiConstant.userManagement.updateMemberRole, method: 'Put', params, formDataFlag: true})
}

export const removeMemberApi= (params) => {
    return Request( {url: `${apiConstant.userManagement.removeMember}?id=${params.id}`, method: 'Delete', formDataFlag: false})
}

export const resendMemberInvitationApi = (params) => {
    return Request({url: `${apiConstant.userManagement.resendMemberInvitation}?id=${params.id}`, method: 'Get' })
}

export const getUserPermissionsApi = (params) => {
    // return Request(`${apiConstant.userManagement.userPermissionList}?scope=${params.scope}&event_id=${params.event_id}`, 'Get' )
   // return Request({url: `${apiConstant.userManagement.userPermissionList}?scope=${params.scope}`, method: 'Get'} )
    if(params?.event_id){
        return Request({url: `${apiConstant.userManagement.userPermissionList}?scope=${params.scope}&event_id=${params.event_id}`, method: 'Get'} )
    }else{
        return Request({url: `${apiConstant.userManagement.userPermissionList}?scope=${params.scope}`, method: 'Get'} )
    }
}


export const getUnverifiedUsersListApi = (params) => {
    return Request({url: apiConstant.userManagement.unverifiedUsers, method: 'Get', params, formDataFlag: false} )
}

export const getUnapprovedUsersListApi = (params) => {
    return Request({url: apiConstant.userManagement.unapprovedUsers, method: 'Get', params, formDataFlag: false} )
}

export const resendUserVerificationLinkApi = (params) => {
    return Request({url: apiConstant.userManagement.resendVerificationLink , method: 'Get', params, formDataFlag: false})
}


export const approveUnapprovedUserApi = (params) => {
    return Request({url: apiConstant.userManagement.approveUser , method: 'Put', params,formDataFlag:  true})
}



///////////////////////////organisation///////////////////////////
export const getAllOrganisationsApi = (params) => {
    return Request({url: apiConstant.organisation.organisationList, method: 'Get', params, formDataFlag: false} )
}


///////////////////////////////////events///////////////////////////////

// export const getOrganisationProjectsApi = (params) => {
//     return Request({url: `${apiConstant.event.projectList}?organisation_id=${params.organisation_id}`, method: 'Get' })
// }

export const getOrganisationProjectsApi = (params) => {
    return Request({url: `${apiConstant.event.projectList}`, method: 'Get' , params})
}

export const viewOrganisationProjectMembersApi = (params) => {
    return Request({url: `${apiConstant.event.viewProjectMembers}?event_id=${params.event_id}`,method:  'Get' })
}

export const assignOrganisationProjectMemberApi = (params) => {
    return Request({url: apiConstant.event.assignProjectMember , method: 'Post', params,formDataFlag:  true})
}

export const updateOrganisationProjectMemberRoleApi = (params) => {
    return Request({url: apiConstant.event.changeProjectMemberRole, method: 'Put', params, formDataFlag: true})
}

export const removeOrganisationProjectMemberApi= (params) => {
    return Request( {url: apiConstant.event.deleteProjectMember, method: 'Delete', params, formDataFlag: true})
}

export const getProjectDetailsApi = (params) => {
    return Request({url: `${apiConstant.event.projectList}/${params.id}?organisation_id=${params.organisation_id}`, method: 'Get' })
}


export const createProjectEditingCycleApi = (params) => {
    return Request({url: apiConstant.event.createEditingCycles , method: 'Post', params, formDataFlag: true})
}

export const getBrandboxAssetsApi = (params) => {
    return Request({url: `${apiConstant.event.brandboxAssets}?event_id=${params.event_id}&organisation_id=${params.organisation_id}`, method: 'Get'} )
}


/////////////////////////////////// revisions ///////////////////////////////



export const getListOfEditingCyclesApi = (params) => {
    return Request({url: apiConstant.revision.editingCycle, method: 'Get', params, formDataFlag: false })
}

export const getInternalRevisionsListApi = (params) => {
    return Request({url: apiConstant.revision.manageInternalRevisions, method:  'Get', params, formDataFlag: false })
}

export const createInternalRevisionApi = (params) => {
    return Request({url: apiConstant.revision.manageInternalRevisions , method: 'Post',params: params.data, formDataFlag: true, progressHandler:params.progress, headers: params.header, controller:params.controller})
}

export const getInternalRevisionDetailsApi = (params) => {
    return Request({url: `${apiConstant.revision.manageInternalRevisions}/${params.id}`, method: 'Get'})
}

export const sendToApproverApi = (params) => {
    return Request({url: `${apiConstant.revision.manageInternalRevisions}/${params.id}/send_to_approver`, method: 'Put'})
}

export const rejectRevisionApi = (params) => {
    return Request({url: `${apiConstant.revision.rejectRevision}?id=${params.id}`, method: 'Put'})
}



export const acceptRevisionApi = (params) => {
    return Request({url: `${apiConstant.revision.acceptRevision}?id=${params.id}&new_filename=${params.new_filename}`, method: 'Post' })
}

///////////////////////////// logs //////////////////////////////////////////


export const createRevisionLogApi = (params) => {
    return Request({url: apiConstant.revision.manageLogs , method: 'Post', params, formDataFlag: true})
}


export const updateRevisionLogApi= (params) => {
    return Request({url: `${apiConstant.revision.manageLogs}/${params.id}`, method: 'Put', params: params.param, formDataFlag: true})
}

export const deleteRevisionLogApi = (params) => {
    return Request({url: `${apiConstant.revision.manageLogs}/${params.id}`, method: 'Delete', params: params.param, formDataFlag: true})
}

export const getRevisionLogsListApi = (params) => {
    return Request({url: `${apiConstant.revision.manageLogs}?internal_revision_id=${params.internal_revision_id}`, method: 'Get' })
}


///////////////////////////////////// permission////////////////////////////////////////////


export const getPermissionsListApi = (params) => {
    return Request({url: `${apiConstant.permission.getPermission}?product_id=${params.id}`, method:  'Get'})
}


//////////////////////////////////// roles ////////////////////////////////////////////////

export const showUserRoleApi = (params) => {
    return Request({url: `${apiConstant.roles.role}/${params.id}`, method: 'Get'})
}


export const getListOfAllRolesApi = (params) => {
    return Request({url: apiConstant.roles.role, method: 'Get', params, formDataFlag: false })
}

///////////////////////////////pharoah apis end //////////////////////////////////////////////////////

